export enum SchedulePopoverType {
    create = 'create',
    edit = 'edit',
}

export enum ScheduleType {
    appointment = 'appointment',
    slot = 'slot',
}
